export const GOOD_COLOR: string = '#00AA00';
export const MEDIUM_COLOR: string = '#FFFB11';
export const RATHER_NOT_COLOR: string = '#FF8106';
export const CANT_COLOR: string = '#FF0000';